import { gql } from '@apollo/client';

const PUSH_START_ECG_STREAMING_QUERY = gql`
  query pushStartEcgStreaming($input: LiveEcgInput!) {
    pushStartEcgStreaming(input: $input) {
      isSuccess
      message
    }
  }
`;

export default PUSH_START_ECG_STREAMING_QUERY;
